export class SubrentalEntryImportModel {
  counter: number = 0;
  inventoryEntryId: number = 0;
  storeCode: number = 0;
  articleCode: number = 0;
  articleName: string = "";
  quantity: number = 0;
  unitValue: number = 0;

  constructor(counter: number = 0,
    inventoryEntryId: number = 0,
    storeCode: number = 0,
    articleCode: number = 0,
    articleName: string = "",
    quantity: number = 0,
    unitValue: number = 0
  ) {
    this.counter = counter;
    this.inventoryEntryId = inventoryEntryId;
    this.storeCode = storeCode;
    this.articleCode = articleCode;
    this.articleName = articleName;
    this.quantity = quantity;
    this.unitValue = unitValue;
  }
}